import AssetViewNavigation from '../AssetViewNavigation.tsx';
import {Trans} from 'react-i18next';
import {Select} from '@mui/material';
import {Asset, AssetRendition} from '../../../../types.ts';
import MenuItem from '@mui/material/MenuItem';
import AssetViewActions from '../Actions/AssetViewActions.tsx';
import {FlexRow} from '@alchemy/phrasea-ui';
import {useLocation} from '@alchemy/navigation';
import type {Location} from '@alchemy/navigation';
import {memo} from 'react';
import {modalRoutes, Routing} from '../../../../routes.ts';
import {useNavigateToModal} from '../../../Routing/ModalLink.tsx';
import {AssetContextState} from '../assetTypes.ts';

type Props = {
    asset: Asset;
    rendition: AssetRendition | undefined;
    renditions: AssetRendition[];
    displayActions: boolean;
    currentStoryAsset?: Asset;
};

function AssetViewHeader({
    asset,
    rendition,
    displayActions,
    renditions,
    currentStoryAsset,
}: Props) {
    const {state} = useLocation() as Location<AssetContextState | undefined>;
    const navigateToModal = useNavigateToModal();
    const handleRenditionChange = (renditionId: string) => {
        navigateToModal(
            modalRoutes.assets.routes.view,
            {
                id: asset.id,
                renditionId: renditionId || Routing.UnknownRendition,
            },
            {
                state,
            }
        );
    };

    const isMainAsset = !currentStoryAsset || currentStoryAsset.id === asset.id;

    return (
        <FlexRow
            style={{
                flexShrink: 1,
            }}
            alignItems={'center'}
        >
            <AssetViewNavigation state={state} currentId={asset.id} />
            <div
                style={{
                    flexShrink: 1,
                }}
            >
                <Trans
                    i18nKey={'asset_view.edit_asset'}
                    values={{
                        name: asset.name,
                    }}
                    defaults={'Asset <strong>{{name}}</strong>'}
                />
            </div>
            {isMainAsset && renditions.length > 0 && (
                <Select<string>
                    sx={{ml: 2}}
                    label={''}
                    size={'small'}
                    value={rendition?.id}
                    onChange={e => handleRenditionChange(e.target.value)}
                >
                    {renditions.map((r: AssetRendition) => (
                        <MenuItem key={r.id} value={r.id}>
                            {r.name}
                        </MenuItem>
                    ))}
                </Select>
            )}
            {isMainAsset && displayActions ? (
                <AssetViewActions asset={asset} file={rendition?.file} />
            ) : (
                ''
            )}
        </FlexRow>
    );
}

export default memo(AssetViewHeader);
